document.addEventListener('DOMContentLoaded', function () {
  // Accordions
  document.querySelectorAll('.description-toggle').forEach(function (container) {
    container.addEventListener('click', function () {
      const targetId = this.querySelector('.toggle-btn').dataset.target;
      const targetElement = document.getElementById(targetId);
      const button = this.querySelector('.toggle-btn');

      if (targetElement.style.maxHeight) {
        targetElement.style.maxHeight = null;
        button.style.transform = 'rotate(0)';
        this.classList.remove('active');
      } else {
        targetElement.style.maxHeight = targetElement.scrollHeight + 'px';
        button.style.transform = 'rotate(180deg)';
        this.classList.add('active');
      }
    });
  });

  // Thumbnail gallery
  const thumbnails = document.querySelectorAll('.thumbnail');
  const mainImage = document.getElementById('productMainImage');

  if (thumbnails.length && mainImage) {
    thumbnails.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbnails.forEach(function (t) {
          t.classList.remove('active');
        });
        this.classList.add('active');
        mainImage.src = this.dataset.src;
        mainImage.srcset = this.dataset.srcset;
      });
    });
  }

  // Alma PDP forms: add → /cart, buy now → add then /checkout
  initAlmaProductForm();
});

function initAlmaProductForm() {
  const form = document.getElementById('product-form');
  if (!form || !form.querySelector('.add-to-cart-btn')) return;
  if (form.dataset.almaFormBound === 'true') return;
  form.dataset.almaFormBound = 'true';

  let submitting = false;
  form.addEventListener('submit', async function (event) {
    event.preventDefault();
    if (submitting) return;

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const submitter = event.submitter;
    const isBuyNow =
      submitter?.classList.contains('buy-now-btn') ||
      submitter?.getAttribute('name') === 'checkout';

    submitting = true;
    const submitButtons = Array.from(form.querySelectorAll('[type="submit"]'));
    submitButtons.forEach(function (btn) {
      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('aria-busy', 'true');
    });

    try {
      const engravingWasActive = Boolean(
        window.ProductEngraving?.isActive?.() && window.ProductEngraving?.buildItemsPayload
      );
      const payload = engravingWasActive
        ? window.ProductEngraving.buildItemsPayload(form)
        : buildSimpleItemsPayload(form);

      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Unable to add to cart');
      }

      if (engravingWasActive && window.syncEngravingCartNoteFromCart) {
        await window.syncEngravingCartNoteFromCart();
      }

      if (isBuyNow) {
        window.location = '/checkout';
      } else {
        window.location = window.routes?.cart_url || '/cart';
      }
    } catch (error) {
      console.error('Alma product form error:', error);
      const engravingError = document.querySelector('[data-engraving-error]');
      if (engravingError) {
        engravingError.hidden = false;
        engravingError.textContent = error.message;
      } else {
        alert(error.message);
      }
      submitting = false;
      submitButtons.forEach(function (btn) {
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-busy');
      });
    }
  });
}

function buildSimpleItemsPayload(form) {
  const formData = new FormData(form);
  const id = Number(formData.get('id'));
  const quantity = Number(formData.get('quantity') || 1) || 1;
  const properties = {};

  for (const [key, value] of formData.entries()) {
    const match = key.match(/^properties\[([^\]]+)\]$/);
    if (match) {
      properties[match[1]] = value;
    }
  }

  const item = { id, quantity };
  if (Object.keys(properties).length) {
    item.properties = properties;
  }

  return { items: [item] };
}
